import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";

function Sell() {
  const [referralApi, setreferralApi] = useState([]);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState(0);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(10);

  const referral_API = async () => {
    try {
      let responceRight = await API?.post("/getselltradereport", {
        uid: search,
      });

      console.log("My_Team", responceRight?.data?.data);
      responceRight = responceRight.data.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          edate: item.edate,
          uid: item?.uid,
          admincharge: ` ${item.admincharge}`,
          remark: item.remark,
          usdtamount: `  ${item.usdtamount} `,
          price: `  ${item.price} `,
          // transtype: item.transtype,
          currencytype: ` ${item.currencytype}/USDT `,
          markettype: item.markettype,
          // transtype: `${item.transtype}`,
          tokenamount: ` ${item.netusdtamount} `,
          transtype: (
            <>
              <button
                className={`${
                  item?.transtype === "Sell" ? "btn-danger" : "btn-green"
                } btn`}
                style={{width:"70px",borderRadius:"13px", padding:"8px 2px"}}
              >
                {item?.transtype}
              </button>
            </>
          ),
          orderid:item?.orderid
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage2,
    indexOfLastPost2
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "UserId", accessor: "uid" },
      { Header: "Order Date & Time", accessor: "edate" },
      { Header: "Order Type", accessor: "transtype" },
      { Header: 'Order Id', accessor: 'orderid' },
      { Header: "Coin", accessor: "currencytype" },
      { Header: "Quantity", accessor: "usdtamount" },
      { Header: "Price", accessor: "price" },
      { Header: "Fees", accessor: "admincharge" },
      { Header: "Total Amount", accessor: "tokenamount" },
      { Header: "Type", accessor: "markettype" },
      { Header: "Action", accessor: "remark" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="container">
            {/* <!-- Inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Sell</h4>
                  </div>
                  <div class="panel-body">
                    <form
                      ng-submit="SearchUserid();"
                      class="ng-pristine ng-valid ng-valid-maxlength"
                    >
                      <div class="form-inline" role="form">
                        <div class="col-md-12">
                          <div class="col-md-2">
                            <input
                              type="text"
                              id="txtuid"
                              ng-model="p.uid"
                              onChange={(e) => setSearch(e.target.value)}
                              class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                              placeholder="Enter UserId"
                              maxLength={6}
                            />
                            &nbsp;&nbsp;
                          </div>
                          <div class="col-md-2 col-xs-12">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => {
                                referral_API();
                              }}
                              class="btn btn-sm btn-primary"
                              value="Search"
                            />
                            &nbsp;&nbsp;
                          </div>
                          &nbsp;&nbsp;
                        </div>
                      </div>
                    </form>
                    <div class="col-md-12"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-default">
                  <div class="panel-body" style={{ overflow: "scroll" }}>
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage2}
                      indexOfLastPost={indexOfLastPost2}
                      setcurrentPage={setcurrentPage2}
                      currentPage={currentPage2}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sell;
